<template>
  <div class="detail">
    <div class="center">
      <div class="address" v-if="showAddress || isGoods">
        <p>收货地址</p>
        <div class="addressDetail" v-if="defaultAddress.receiverName">
          <div>
            <p><span>收货人:</span>{{ defaultAddress.receiverName }}</p>
            <p><span>联系方式:</span>{{ defaultAddress.mobile }}</p>
            <p>
              <span>收货地址:</span>{{ defaultAddress.province }}{{ defaultAddress.city }}{{ defaultAddress.district
              }}{{ defaultAddress.details }}
            </p>
          </div>
          <ul v-if="defaultAddress.receiverName">
            <li class="addAdd" @click="appendAddress">添加地址</li>
            <li class="changeAdd" @click="addressChangeMask = true">切换地址</li>
            <li class="updateAdd" @click="editAddress">修改地址</li>
          </ul>
        </div>
        <div class="noDefault" v-else @click="addressMask = true">
          <i class="el-icon-warning"></i>&nbsp;您没有设置默认地址，点击设置
        </div>
      </div>
      <div class="invoice" v-if="isGoods1">
        <p>发票信息</p>
        <div class="invoDetail">
          <div class="radio" :class="{ 'radio-checked': invoiceChoose }" @click="invoiceChoose = !invoiceChoose">
            我需要开发票
          </div>
          <div>发票类型:&nbsp;&nbsp;普通发票(纸张)</div>
          <div v-if="invoiceChoose && invoiceMsg.headFill" class="fillTitle">
            发票抬头:&nbsp;&nbsp;{{ invoiceMsg.headFill }}
          </div>
          <div v-if="invoiceChoose && invoiceMsg.contentText">内容:&nbsp;&nbsp;{{ invoiceMsg.contentText }}</div>
          <div v-if="invoiceChoose && invoiceMsg.contentText">
            发票金额:&nbsp;&nbsp;{{ compoutedPrice.totalFee | currency('￥', 2) }}
          </div>
          <div class="changeMsg" @click="invoiceMask = true">修改信息</div>
        </div>
      </div>
      <div class="orderDetail">
        <p>订单信息</p>
        <div class="ordDetail">
          <div class="head">
            <span>商品信息</span>
            <span>单价</span>
            <span>数量</span>
            <span>小计</span>
            <span>实付</span>
          </div>
          <ul v-for="(order, index) in goodsList" :key="index + 'out'">
            <div>
              <li
                :class="{ noFirstMainCommodity: index !== 0 }"
                v-for="(orderitem, i) in goodsList[index].orderItemDtoList"
                :key="i"
                @click="toDetails(orderitem)"
                style="cursor: pointer"
              >
                <div>
                  <div class="lileft" :style="'background-image: url(' + orderitem.itemImage + ')'"></div>
                  <div class="liright" v-if="orderitem.itemType !== '0'">
                    <p>
                      <!--抽奖标签-->
                      <span class="prizeTab" v-if="orderChannel === 3 || orderChannel === '3'"></span>
                      <span class="activityTag" v-if="orderitem.extraMap.bofogPurchase">赠品</span>
                      <span class="activityTag" v-if="orderitem.extraMap.collocationPurchase">搭配购</span>
                      <!-- 活动标签 -->
                      <!-- <span class="deposit-box">
                      <img
                        v-if="
                          orderitem.extraMap &&
                            orderitem.extraMap.activity &&
                            orderitem.extraMap.activity.activityType == 18
                        "
                        class="deposit-tag"
                        src="../../assets/images/activity/deposit-tag.png"
                      />
                    </span> -->
                      <span
                        v-if="orderitem.extraMap && orderitem.extraMap.activity"
                        :class="orderitem.extraMap.activity.activityType !== 18 ? 'activityTag' : 'deposit-tag'"
                        >{{ orderitem.extraMap.activity.tag }}</span
                      >{{ orderitem.itemName }}
                    </p>
                    <template v-if="orderitem.attributeMaps">
                      <p v-for="(attr, i) in orderitem.attributeMaps" :key="i">
                        <span>{{ attr.attrKey }}：{{ attr.attrVal }}</span>
                      </p>
                    </template>
                  </div>
                  <div class="liright" v-else>
                    <p>
                      <!--抽奖标签-->
                      <span class="prizeTab" v-if="orderChannel === 3 || orderChannel === '3'"></span>
                      <!-- 活动标签 -->
                      <span
                        v-if="
                          orderitem.extraMap && orderitem.extraMap.activity && orderitem.extraMap.activity.activityType
                        "
                        class="activityTag"
                        >{{ orderitem.extraMap.activity.tag }}</span
                      >
                      {{ orderitem.itemName }}&nbsp;
                    </p>
                    <!-- <p v-if="orderitem.extra && orderitem.extra.guidePrice">
                    官方指导价:{{ orderitem.extra.guidePrice }}
                  </p>
                  <p v-else>价格:{{ Number(orderitem.originFee) | currency('￥', 2) }}</p> -->
                    <p>
                      官方指导价:{{
                        orderitem.extraMap && orderitem.extraMap.originPrice ? orderitem.extraMap.originPrice : 0
                      }}
                    </p>
                    <p>经销商：{{ getDealNameByExtraMap(orderitem.extraMap) }}</p>
                  </div>
                </div>
                <div>{{ orderitem.skuPrice | currency('￥', 2) }}</div>
                <div>x{{ orderitem.quantity }}</div>
                <div>{{ orderitem.originFee | currency('￥', 2) }}</div>
                <div>{{ orderitem.fee | currency('￥', 2) }}</div>
                <!-- <p class="btnOftoggle" @click.stop="toggleClick(order)">
                {{ order.show ? '收起' : '展开' }}
              </p> -->
              </li>
            </div>
          </ul>
          <div class="Vincode" v-if="isGoods2">
            <span>VIN码</span>
            <el-select
              v-model="Vinvalue"
              placeholder="可兑换时选择或使用时选择"
              @focus="getVIN"
              no-data-text="请先绑定vin码"
            >
              <el-option v-for="(item, index) in Vinoptions" :key="index" :label="item.vin" :value="item.vin">
              </el-option>
            </el-select>
          </div>
          <div class="coupon" v-if="isGoods3 && isShowCoupon">
            <span>优惠券</span>
            <el-select
              :class="Couponvalue ? 'selcetCoupon' : ''"
              v-model="Couponvalue"
              placeholder="选择优惠券"
              clearable
              @change="getCoupon"
              @clear="noUseCoupon"
            >
              <el-option
                v-for="(item, index) in Couponoptions"
                :key="index"
                :label="item.name"
                :value="item.couponCode"
              >
              </el-option>
            </el-select>
            <p>
              共有{{ allCoupon }}张优惠券&nbsp;其中<span>{{ useCoupon }}</span
              >张可用
            </p>
          </div>
        </div>
      </div>
      <!-- 商品明细 -->
      <div class="amountDetails">
        <p>商品明细</p>
        <ul class="amDetails">
          <li>
            <span>商品件数:</span><span>{{ goodsNumber }}件</span>
          </li>
          <li>
            <span v-if="vmId === 5 || vmId === '5'">商品总积分:</span><span v-else>商品总价:</span
            ><span style="color: #c6001f">{{ compoutedPrice.tempFee | currency('￥', 2) }}</span>
          </li>
          <li v-if="showSome">
            <span>活动优惠:</span><span>{{ compoutedPrice.eventDiscount | currency('￥', 2) }}</span>
          </li>
          <li v-if="showSome">
            <span>优惠券抵扣:</span><span>{{ compoutedPrice.couponDiscount | currency('￥', 2) }}</span>
          </li>
          <!-- <li >
            <span>运费:</span><span>{{ compoutedPrice.shipFee | currency('￥', 2) }}</span>
          </li> -->
          <li>
            <span>应付总额:</span><span style="color: #c6001f;font-size:32px;font-weight:500;">{{ compoutedPrice.totalFee | currency('￥', 2) }}</span>
          </li>
        </ul>
      </div>
      <div class="button">
        <el-button type="primary" :loading="orderPush" class="submit" @click="orderConfirm">提交订单</el-button>
      </div>
    </div>
    <InvoiceFill :show.sync="invoiceMask" @invoice="invoiceConfirm"></InvoiceFill>
    <EditAddress
      :show.sync="addressMask"
      :preAddress="addressMsg"
      @success="addressConfirm"
      :isDefault="defaultAddress.receiverName ? false : true"
    ></EditAddress>
    <ChangeAddress
      :show.sync="addressChangeMask"
      @changeAddress="changeConfirm"
      @openAdd="appendAddress"
    ></ChangeAddress>
  </div>
</template>

<script type="text/javascript">
// import { Dialog, Button, Cascader } from 'element-ui'
// import { orderActivityRoute } from '@/lib/utils'
import { Button } from 'element-ui'
import InvoiceFill from '../../components/business/order/invoiceFill'
import ChangeAddress from '../../components/business/order/changeAddress'
import EditAddress from '../../components/business/address/addressEdit'
import orderApi from '@/api/order.js'
import { getStorage } from '@/lib/utils'
/* eslint-disable */
export default {
  name: 'order-confirm',
  data() {
    return {
      children: [{}, {}, {}],
      // activityTag: {
      //   2: '搭配购',
      //   3: '抽奖类',
      //   5: '限时抢购',
      //   6: '团购',
      //   8: '集客',
      //   9: '主题',
      //   10: '投票',
      //   11: '裂变',
      //   14: '签到集卡',
      //   16: '邀请下单',
      //   18: '预售',
      //   19: '神券',
      //   20: '拍卖',
      //   21: '买赠'
      // },
      showAddress: false,
      showSome: true /* 【优惠券选择】【活动优惠】【优惠券】显隐 true显示，false隐藏 */,
      orderChannel: '', //抽奖标签
      itemType: '', //判断是否为精品
      vmId: '',
      orderPush: false,
      isGoods: false, //收货地址
      isGoods1: true, //发票信息
      isGoods2: false, //VIN码
      isGoods3: false, //优惠券
      addressMsg: {}, // 收货地址信息
      defaultAddress: {
        addressType: '',
        id: '',
        receiverName: '',
        mobile: '',
        zipCode: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        details: '',
        isDefault: ''
      },
      addressId: '',
      addressChangeMask: false, // 选择收货地址弹出,
      addressMask: false, // 发货地址弹出
      invoiceChoose: false, // 发票选择按钮
      invoiceMsg: {
        contentText: '', // 选择内容
        headFill: '', // 发票抬头
        invoiceType: 0 //发票类型
      },
      invoiceMask: false, // 发票弹出
      allCoupon: 0,
      useCoupon: 0,
      isShowCoupon: true,
      goodsList: [],
      compoutedPrice: {
        totalFee: 0, // 应付总额
        eventDiscount: 0, //活动优惠
        couponDiscount: 0, //优惠券折扣
        shipFee: 0, // 总运费
        tempFee: 0 // 商品总积分
      },
      input: '',
      Vinoptions: [],
      Vinvalue: '',
      Couponoptions: [],
      Couponvalue: '',
      publishId: '',
      couponCode: '',
      goodsNumber: 0,
      equitys: [], // 订金升档权益
      itemId: 0 // 商品id
    }
  },
  computed: {
    orderId() {
      return this.$route.params.orderId
    }
  },
  components: {
    // elDialog: Dialog,
    elButton: Button,
    InvoiceFill,
    ChangeAddress,
    EditAddress
    // elCascader: Cascader
  },
  /* eslint-disable */
  methods: {
    toggleClick(order) {
      if (!('show' in order)) {
        this.$set(order, 'show', true)
      } else {
        this.$set(order, 'show', !order.show)
      }
    },
    // 进入商品详情页
    toDetails(item) {
      // 如果是赠品跳转到主商品页面
      if (item.extraMap.bofogPurchase) {
        this.goodsList.forEach((item) => {
          item.orderItemDtoList.forEach((res) => {
            if (res.extraMap.activity) {
              this.toDetails(res)
            }
          })
        })
        return
      }
      let url = ''
      if (item.itemType === '0' || item.itemType === 0) {
        if (item.extraMap.activity && item.extraMap.activity.activityId) {
          url = `/details/allCars?activityId=${item.extraMap.activity.activityId}&id=${item.itemId}`
        } else {
          url = `/details/allCars?id=${item.itemId}`
        }
      } else {
        if (item.extraMap.activity && item.extraMap.activity.activityId) {
          url = `/details/boutiqueAccessories?activityId=${item.extraMap.activity.activityId}&id=${item.itemId}`
        } else {
          url = `/details/boutiqueAccessories?id=${item.itemId}`
        }
      }
      this.$router.push({ path: url })
    },
    findDefaultAddrByUserId() {
      // 默认地址
      orderApi.findDefaultAddrByUserId().then((res) => {
        // this.isGoods = true
        if (res.status === 200) {
          Object.keys(this.defaultAddress).forEach((key) => {
            this.defaultAddress[key] = res.data[key]
          })
        }
      })
    },
    getVIN() {
      orderApi.getVIN().then((res) => {
        if (res.status === 200) {
          this.Vinoptions = res.data
          console.log(1, this.Vinoptions)
          if (res.data.length == 0) {
            this.$feedback('请先绑定VIN码')
          }
        }
      })
    },
    getCoupon() {
      if (this.Couponvalue) {
        this.Couponoptions.forEach((val) => {
          if (val.couponCode === this.Couponvalue) {
            this.publishId = val.publishId
          }
        })
        if (this.publishId) {
          orderApi
            .getCoupon({ orderId: this.orderId, publishId: this.publishId, couponCode: this.Couponvalue })
            .then((res) => {
              if (res.status === 200) {
                this.goodsList = res.data.orderContracts
                if (res.data.orderDiscounts) {
                  res.data.orderDiscounts.forEach((val) => {
                    if (val.type === '2' || val.type === 2) {
                      this.compoutedPrice.eventDiscount = val.discount
                    }
                    if (val.type === '1' || val.type === 1) {
                      this.compoutedPrice.couponDiscount = val.discount
                    }
                  })
                }
                this.compoutedPrice.shipFee = res.data.order.shipFee
                this.compoutedPrice.totalFee = res.data.order.fee
                this.compoutedPrice.tempFee = res.data.order.originFee
              }
            })
        }
      }
    },
    noUseCoupon() {
      orderApi.getCoupon({ orderId: this.orderId }).then((res) => {
        if (res.status === 200) {
          this.goodsList = res.data.orderContracts
          this.compoutedPrice.eventDiscount = 0
          this.compoutedPrice.couponDiscount = 0
          this.compoutedPrice.shipFee = res.data.order.shipFee
          this.compoutedPrice.totalFee = res.data.order.fee
          this.compoutedPrice.tempFee = res.data.order.originFee
        }
      })
      this.Couponvalue = ''
      this.publishId = ''
    },
    getSelectedAttrNameByAttributeMap(attributeMap) {
      if (!attributeMap || !(attributeMap.reduce instanceof Function)) {
        return ''
      }
      return attributeMap.reduce((total, next, i, attr) => {
        return (
          total +
          Object.keys(next.attributeMap).reduce((ctotal, cnext, ci, cattr) => {
            return ctotal + (i === 0 && ci === 0 ? '' : '/') + next.attributeMap[cnext]
          }, '')
        )
      }, '')
    },
    getDealNameByExtraMap(extraMap) {
      return extraMap && extraMap.dealer && extraMap.dealer.dealerName ? extraMap.dealer.dealerName : '暂无'
    },
    getOrderList() {
      // 获取订单详情
      orderApi.getDetail({ orderId: this.orderId }).then((res) => {
        if (res.status === 200) {
          if (res.data.order && res.data.order.equitys) {
            this.equitys = res.data.order.equitys
          }
          this.itemId = res.data.orderContracts && res.data.orderContracts[0].orderItemDtoList[0].itemId
          this.vmId = res.data.order.vmId
          this.orderChannel =
            res.data.order.extraMap && res.data.order.extraMap.orderChannel ? res.data.order.extraMap.orderChannel : ''
          this.goodsList = res.data.orderContracts
          // 只要有不是整车和卡券的商品存在，就得有收获地址
          let hasAddr = false
          res.data.orderContracts.forEach((val) => {
            this.goodsNumber += val.orderItemDtoList.length
            val.orderItemDtoList.forEach((i) => {
              if (i.itemType === '1' || i.itemType === '2' || i.itemType === '4') {
                hasAddr = true
              }
              if (i.itemType === '0') {
                //整车不显示收货地址和发票信息
                this.isGoods1 = false
                this.isGoods = false
              }
              if (i.itemType === '3') {
                //卡券填VIN
                this.isGoods2 = true
                this.isGoods = false
              }
              if (i.itemType === '1' || i.itemType === '2') {
                //只有精品、备件、卡券商品可以使用优惠券
                this.isGoods3 = true
              }
              if (i.itemType === '2') {
                // 判断精品地址不为空
                this.itemType === 2
              }
              if (i.itemType === '1' || i.itemType === '2' || i.itemType === '4') {
                //只要订单中有精品、备件、自采购商品，都需要显示收货地址
                this.isGoods = true
              }
            })
          })
          if (hasAddr) {
            this.isGoods = true
          }
          this.goodsList.forEach((val) => {
            val.orderItemDtoList.forEach((i) => {
              if (i.itemType === '0') {
                // 整车不显示【优惠券选择】【活动优惠】【优惠券】
                // 【运费】不显示
                this.showSome = false
              }
            })
          })
          res.data.orderDiscounts.forEach((val) => {
            if (val.type === '2' || val.type === 2) {
              this.compoutedPrice.eventDiscount = val.discount
            }
            if (val.type === '1' || val.type === 1) {
              this.compoutedPrice.couponDiscount = val.discount
            }
          })
          this.compoutedPrice.shipFee = res.data.order.shipFee
          this.compoutedPrice.totalFee = res.data.order.fee
          this.compoutedPrice.tempFee = res.data.order.originFee
          if (res.data.unableCoupons != null && res.data.ableCoupons != null) {
            this.allCoupon = res.data.unableCoupons.length + res.data.ableCoupons.length
            this.useCoupon = res.data.ableCoupons.length
            this.Couponoptions = res.data.ableCoupons
            for (let i = 0; i < this.Couponoptions.length; i++) {
              if (this.Couponoptions[i].useStatus == 1) {
                this.Couponvalue = this.Couponoptions[i].couponCode
                this.publishId = this.Couponoptions[i].publishId
              }
            }
          }
          if (res.data.order.extraMap.activity) {
            this.isShowCoupon = false
          }

          if (res.data.order.extraMap && res.data.order.extraMap.supportDeliveryAddress) {
            this.showAddress = res.data.order.extraMap.supportDeliveryAddress === 1
          }
        }
      })
    },
    Invoicedialog() {
      this.show = true
    },
    invoiceConfirm(data) {
      // 发票填写返回数据
      Object.assign(this.invoiceMsg, data)
      this.invoiceChoose = true
    },
    editAddress() {
      this.addressMsg = Object.assign({}, this.defaultAddress)
      this.addressMask = true
    },
    appendAddress() {
      // 添加地址
      this.addressMsg = {}
      this.addressMask = true
    },
    addressConfirm(data) {
      // 添加地址返回数据
      Object.assign(this.defaultAddress, data)
      this.defaultAddress.id = data.id
    },
    changeConfirm(data) {
      // 更改地址返回数据
      Object.assign(this.defaultAddress, data)
      this.defaultAddress.id = data.id
    },
    orderConfirm() {
      // 订单确认
      if (!!this.isGoods) {
        if (
          this.defaultAddress.province === undefined ||
          this.defaultAddress.city === undefined ||
          this.defaultAddress.province === '' ||
          this.defaultAddress.city === ''
        ) {
          // 新用户没地址
          this.itemType === 2 ? this.$feedback('购买精品地址不能为空') : this.$feedback('您还没有默认收货地址')
          return
        }
      }
      if (this.isGoods1) {
        if (this.invoiceChoose) {
          if (
            this.invoiceMsg.contentText === undefined ||
            this.invoiceMsg.headFill === undefined ||
            this.invoiceMsg.contentText === '' ||
            this.invoiceMsg.headFill === ''
          ) {
            this.$feedback('已勾选填写发票,请填写发票内容')
            return
          }
        }
      }
      const param = {
        orderId: this.orderId,
        vin: this.Vinvalue
      }
      /**
       * 因为买赠中可能会有需要地址的商品，就直接给地址了
       */
      param.userAddressId = this.defaultAddress.id
      // if (this.isGoods) {
      //   param.userAddressId = this.defaultAddress.id
      // }
      if (this.isGoods3) {
        param.couponCode = this.Couponvalue
        param.publishId = this.publishId
      }
      if (this.invoiceChoose) {
        param.invoiceDto = {
          invoiceType: this.invoiceMsg.invoiceType,
          invoiceTitle: this.invoiceChoose ? this.invoiceMsg.headFill : '',
          invoiceContent: this.invoiceChoose ? this.invoiceMsg.contentText : ''
        }
      }
      this.orderPush = true
      orderApi.orderConfirm(param).then(
        (res) => {
          if (res.status === 200) {
            window.Countly.q.push([
              'add_event',
              {
                key: 'pc#orderConfirm',
                segmentation: {
                  ea: '提交订单',
                  ds_: 'web',
                  tid: 10,
                  in_: this.itemId,
                  dl: window.location.href,
                  host: window.location.host,
                  media: 100012,
                  uid: getStorage('userInfo') && getStorage('userInfo').accountId,
                  tc: this.orderId
                }
              }
            ])
            this.$store.commit('getEquitys', this.equitys)
            this.$router.push('/order/payConfirm/' + this.orderId)
          } else {
            this.$feedback(res.message)
          }
          this.orderPush = false
        },
        (res) => {
          this.$feedback(res.message)
          this.orderPush = false
        }
      )
    }
  },
  created() {
    this.findDefaultAddrByUserId()
    this.getOrderList()
  }
}
</script>

<style scoped lang="scss">
.detail {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
}
.center {
  width: 1360px;
  margin: 0 auto;
  padding: 19px 0 51px;
  line-height: 38px;
  font-size: 16px;
  color: #333;
  input {
    font-size: 16px;
  }
  .address {
    > p {
      font-weight: 600;
      font-size: 18px;
      line-height: 55px;
      color: rgba(51, 51, 51, 1);
    }
    ul {
      /*width: 100%;*/
      overflow: hidden;
      background: #f9f9f9;
      width: 500px;
      li {
        float: right;
        color: #666;
        padding-left: 26px;
        background-size: 20px 20px;
        margin-left: 45px;
        cursor: pointer;
        text-decoration: underline;
      }
      li:nth-of-type(1) {
        background: url('../../assets/images/order-confirm/add.png') no-repeat left center;
      }
      li:nth-of-type(2) {
        background: url('../../assets/images/order-confirm/update.png') no-repeat left center;
      }
      li:nth-of-type(2):hover {
        background-image: url('../../assets/images/order-confirm/update-fo.png');
      }
      li:nth-of-type(3) {
        background: url('../../assets/images/order-confirm/change.png') no-repeat left center;
      }
      li:nth-of-type(3):hover {
        background-image: url('../../assets/images/order-confirm/change-fo.png');
      }
    }
    .addressDetail {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      border-top: 4px solid #c6001f;
      background: #f9f9f9;
      padding: 15px 30px;
      /*max-width: 970px;*/
      box-sizing: border-box;
      div {
        span {
          display: inline-block;
          width: 83px;
        }
      }
    }
    .noDefault {
      color: #da1e46;
      text-align: center;
      background: #f9f9f9;
      cursor: pointer;
    }
  }
  .invoice {
    margin-top: 20px;
    > p {
      font-size: 18px;
      font-weight: 600;
      line-height: 55px;
      color: rgba(51, 51, 51, 1);
    }
    .invoDetail {
      overflow: hidden;
      padding: 30px 30px 20px 39px;
      background-color: #f9f9f9;
      box-sizing: border-box;
      position: relative;
      height: 80px;
      line-height: 80px;
      border-bottom: 0px solid #666;
      > div {
        margin-left: 50px;
        color: #666;
        float: left;
        line-height: 20px;
      }
      .radio {
        color: #333;
        padding: 0px 35px 0 30px;
        line-height: 20px;
        margin-left: 0;
        height: 20px;
        font-weight: 600;
        border-right: 1px solid #d4d4d4;
        cursor: pointer;
        background: url('../../assets/images/order-confirm/default.png') no-repeat left center;
      }
      .radio-checked {
        background-image: url('../../assets/images/order-confirm/invoice.png');
      }
      .changeMsg {
        float: right;
        cursor: pointer;
      }
      .fillTitle {
        max-width: 600px;
      }
    }
  }
  .orderDetail {
    margin-top: 20px;
    > p {
      font-weight: 600;
      font-size: 18px;
      line-height: 55px;
      // color: rgba(51, 51, 51, 1);
    }
    .ordDetail {
      width: 100%;
      line-height: 49px;
      overflow: hidden;
      border: 1px solid rgba(208, 208, 208, 1);
      .head {
        padding: 0 30px;
        background: #000;
        height: 49px;
        color: #fff;
        span {
          text-align: right;
          float: left;
          width: 12%;
        }
        span:first-of-type {
          text-align: left;
          width: 45%;
        }
      }
      ul {
        background: #fff;
        padding: 0 30px;

        li {
          border-bottom: 1px dashed #b4b4b4;
          &.noFirstMainCommodity {
            // border-top: 1px dashed #d0d0d0;
          }
          height: 187px;
          > div {
            text-align: right;
            float: left;
            width: 12%;
            font-size: 18px;
            line-height: 187px;
          }
          > div:first-of-type {
            display: flex;
            width: 45%;
            text-align: left;
            margin: 22px 0;
            .lileft {
              width: 202px;
              height: 143px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .lileft-child {
              width: 80px;
              height: 80px;
              position: relative;
              top: -13px;
            }
            .liright {
              flex: 1;
              padding: 0 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .activityTag {
                padding: 0 3px;
                color: #fff;
                background: #df3d36;
                font-weight: 400;
                height: 18px;
                font-size: 16px;
                font-family: PingFangSC;
                font-weight: 500;
                line-height: 18px;
              }
              .deposit-tag {
                background: linear-gradient(145deg, #ef5d42 0%, #da1f46 100%);
                padding: 0 3px;
                color: #fff;
                font-weight: 400;
                height: 18px;
                font-size: 16px;
                font-family: PingFangSC;
                font-weight: 500;
                line-height: 18px;
              }
              .deposit-box {
                height: 26px;
                line-height: 16px;
                display: inline-table;
                vertical-align: bottom;
                margin-right: 5px;
                .deposit-tag {
                  width: 70px;
                  height: 30px;
                }
              }
              p {
                line-height: 32px;
                font-size: 16px;
              }
              p:first-of-type {
                font-weight: 600;
                font-size: 18px;
                line-height: 35px;
                margin-top: 15px;
                white-space: initial;
              }
            }
            .liright-child {
              p:first-of-type {
                line-height: 15px;
                margin-top: 8px;
              }
            }
            .prizeTab {
              display: block;
              width: 42px;
              height: 25px;
              background: url('../../assets/images/activity/lottery/prize.png') no-repeat;
              background-size: 100% 100%;
              float: left;
              margin-top: 5px;
              margin-right: 6px;
            }
          }
          > div:last-of-type {
            color: #c6001f;
          }
          .btnOftoggle {
            line-height: 187px;
            text-align: center;
            display: inline-block;
            color: #4ba0f8;
            // border: 2px solid red;
            padding: 0 25px;
          }
        }
        .childCommodity {
          height: 100px;
          margin-left: 67px;
          overflow: hidden;

          > div {
            line-height: 100px;
          }
        }
        .childUl {
          padding: 0;
        }
      }
      ::v-deep .Vincode {
        padding: 0 30px;
        margin-top: 20px;
        margin-bottom: 30px;
        display: flex;
        .el-select {
          .el-input {
            display: inline-block;
            width: 430px;
            height: 40px;
            margin-left: 30px;
            .el-input__inner {
              position: relative;
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              line-height: 22px;
            }
            .el-select__caret {
              display: inline-block;
              background: url('../../assets/images/order/new_dropdwon.png') center center no-repeat;
              background-size: 18px 12px;
            }
            ::v-deep .el-icon-circle-close {
              position: absolute;
              right: 100px;
            }
            .el-icon-arrow-up:before {
              content: '';
            }
          }
        }
      }
    }
    ::v-deep .coupon {
      padding: 0 30px;
      margin-top: 20px;
      margin-bottom: 30px;
      .el-select {
        .el-input {
          display: inline-block;
          width: 430px;
          height: 40px;
          margin-left: 30px;
          .el-input__inner {
            position: relative;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 22px;
            padding-right: 100px;
          }
          .el-select__caret {
            display: inline-block;
            background: url('../../assets/images/order/new_dropdwon.png') center center no-repeat;
            background-size: 18px 12px;
          }
          // .el-select__caret:hover {
          //   background: none;
          // }

          ::v-deep .el-icon-circle-close {
            position: absolute;
            left: -100px;
          }
          .el-icon-arrow-up:before {
            content: '';
          }
        }
      }
      .selcetCoupon {
        .el-input:hover {
          .el-select__caret {
            background: none;
          }
        }
      }
      > p {
        margin-left: 76px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        margin-top: 7px;
        span {
          // color: #c6001f;
          color: #c6001f;
        }
      }
    }
  }

  .amountDetails {
    margin-top: 20px;
    padding-bottom: 40px;
    > p {
      font-weight: 600;
      font-size: 18px;
      line-height: 55px;
    }
    .amDetails {
      width: 100%;
      overflow: hidden;
      border-top: 1px solid rgba(208, 208, 208, 1);
      > li {
        width: 100%;
        overflow: hidden;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top: 7px;
        span:first-child {
          float: left;
        }
        span:last-child {
          float: right;
        }
      }
      > li:last-child {
        font-size: 23px;
        font-weight: 500;
        color: #333333;
        margin-top: 32px;
      }
      > li:nth-child(2) span:last-child{
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .button {
    width: 100%;
    overflow: hidden;
    .submit {
      float: right;
      border: 0;
      width: 324px;
      height: 56px;
      font-size: 20px;
      background: #c6001F;
      color: #fff;
      font-size: 20px;
      font-weight:600;
      border-radius: 0;
    }
  }
}
</style>
